<template>
  <div>
      <v-layout wrap align-center justify-center class="px-2">
            <v-flex xs12>
                <div class="title primary--text">
                    <h4>
                        {{ $t("enrollment.steps.ask_password.component.title") }}
                    </h4>
                </div>
                <div class="py-3 subheading">
                    <h4 class="d-inline-block">{{ email }}</h4>
                    <a class="primary--text" @click.stop="goToStep(DEFINES.ENROLLMENT_STEPS.LOGIN)">
                        {{ $t(`${eventPrefix}.change.label`) }}
                    </a>
                </div>
            </v-flex>
            <v-flex xs12>
                <v-form ref="passwordForm" onsubmit="return false;">
                    <v-text-field
                    outline
                    color="secondary"
                    :label="$t('rms.field.password.label')"
                    name="password"
                    :placeholder="$t('rms.field.password.label')"
                    :rules="[rules.required, rules.min_length(6)]"
                    prepend-inner-icon="lock"
                    type="password"
                    v-model="password"
                    ></v-text-field>
                    <div class="pt-2 pb-3">
                        <!-- Forgot password -->
                        <div class="pt-0 text-xs-center subheading">
                            <span class="secondary--text text--lighten-2">
                                {{ $t("enrollment.steps.verification.forgot_password") }}
                            </span>
                            <a @click.stop="resetPassword()">
                                <strong class="primary--text">
                                    {{ $t("enrollment.steps.verification.reset_password") }}
                                </strong>
                            </a>
                        </div>
                        <div v-if="is_email_verified" class="me-divider-break">
                            <h5 class="text-in-between-divider">
                                {{ $t(`${eventPrefix}.or.label`) }}
                            </h5>
                        </div>
                        <!-- Login with Code in case of phone number already saved-->
                        <div v-if="is_email_verified && phone" class="pt-0 text-xs-center">
                            <a @click.stop="resendVerification(true,DEFINES.ENROLLMENT_STEPS.ASK_OTP,false)">
                                <strong class="primary--text subheading">
                                {{ $t("enrollment.steps.verification.login_with_otp") }}
                                </strong>
                            </a>
                        </div>
                        <!-- Login with Code in case of phone number not saved then first ask for it & then send -->
                        <div v-if="is_email_verified && !phone" class="pt-0 text-xs-center">
                            <a @click.stop="goToStep(DEFINES.ENROLLMENT_STEPS.ASK_PHONE)">
                                <strong class="primary--text subheading">
                                    {{ $t("enrollment.steps.verification.login_with_otp") }}
                                </strong>
                            </a>
                        </div>
                    </div>
                </v-form>
            </v-flex>
        </v-layout>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                :class="[$vuetify.rtl ? 'ml-2' : '']"
                color="primary background--text"
                dark
                @click="onCancel"
                >{{ $t(`${eventPrefix}.btn.cancel`) }}</v-btn
            >
            <v-btn
                :class="[$vuetify.rtl ? 'mx-0' : '']"
                color="primary background--text"
                :loading="loading"
                :disabled="loading"
                @click.prevent="onConfirm"
                >{{ $t("enrollment.steps.verify.button") }}</v-btn
            >
        </v-card-actions>
  </div>
</template>

<script>
import rules from "@/validation";

export default {
    name:"EnrollmentAskPassword",
     props:{
        eventPrefix: {
            type: String,
            default: 'screener'
        },
        email:{
            type: String,
            default: null
        },
        is_email_verified:{
            default: false
        },
        phone:{
            default: null
        },
        loading:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            rules,
            password:null
        }
    },
    watch:{
        password(){
            this.$emit("update:password",this.password);
        }
    },
     methods:{
        goToStep(step){
            this.$emit("onChange",step);
        },
        resetPassword(){
            this.$emit("onReset");
        },
        resendVerification(is_phone, redirectTo, showMessage){
            this.$emit("onResend",is_phone, redirectTo, showMessage)
        },
        onCancel(){
            this.$emit("onCancel");
        },
        onConfirm(){
            this.$emit("onConfirm");
        },
        validate(){
            return this.$refs.passwordForm.validate();
        }
    }
}
</script>

<style>

</style>
